import { render, staticRenderFns } from "./crm-candidates.vue?vue&type=template&id=0590622d&"
import script from "./crm-candidates.vue?vue&type=script&lang=js&"
export * from "./crm-candidates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports